export enum SortByColumnKeys {
  CARE_COORDINATOR = 'careCoordinator'
}
export enum SortByColumnValues {
  CARE_COORDINATOR = 'careCoordinator.name'
}
